import { render, staticRenderFns } from "./portGroup.vue?vue&type=template&id=5a662909&"
import script from "./portGroup.vue?vue&type=script&lang=js&"
export * from "./portGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a662909')) {
      api.createRecord('5a662909', component.options)
    } else {
      api.reload('5a662909', component.options)
    }
    module.hot.accept("./portGroup.vue?vue&type=template&id=5a662909&", function () {
      api.rerender('5a662909', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/portGroup.vue"
export default component.exports